import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALWEBSITE_LOAD_BY_TRIAL_ID,
    ACTION_TRIALWEBSITE_LOAD_BY_ID,

    ACTION_TRIALWEBSITE_SAVE,

    ACTION_TRIALWEBSITE_CREATE,

    ACTION_TRIALWEBSITE_VALIDATE,

    ITrialWebsiteLoadByTrialIdAction,
    ITrialWebsiteLoadByIdAction,
    ITrialWebsiteLoadFailureAction,
    ITrialWebsiteLoadSuccessAction,

    ITrialWebsiteSaveAction,
    ITrialWebsiteSaveSuccessAction,
    ITrialWebsiteSaveFailureAction,

    ITrialWebsiteCreateAction,
    ITrialWebsiteCreateSuccessAction,
    ITrialWebsiteCreateFailureAction,

    ITrialWebsiteValidateAction,
    ITrialWebsiteValidateSuccessAction,
    ITrialWebsiteValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialWebsite";
import { trialWebsiteApi } from "../services/trialWebsite";

export const
    getTrialWebsiteByTrialIdEpic = (action$): Observable<ITrialWebsiteLoadSuccessAction | ITrialWebsiteLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALWEBSITE_LOAD_BY_TRIAL_ID)
            .mergeMap((action: ITrialWebsiteLoadByTrialIdAction) => {
                return trialWebsiteApi
                    .getTrialWebsiteByTrialId(action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialWebsite, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialWebsiteByIdEpic = (action$): Observable<ITrialWebsiteLoadSuccessAction | ITrialWebsiteLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALWEBSITE_LOAD_BY_ID)
            .mergeMap((action: ITrialWebsiteLoadByIdAction) => {
                return trialWebsiteApi
                    .getTrialWebsiteById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialWebsite, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialWebsiteEpic = (action$): Observable<ITrialWebsiteSaveSuccessAction | ITrialWebsiteSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALWEBSITE_SAVE)
            .mergeMap((action: ITrialWebsiteSaveAction) => {
                return trialWebsiteApi
                    .setTrialWebsite(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialWebsite, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialWebsiteEpic = (action$): Observable<ITrialWebsiteCreateSuccessAction | ITrialWebsiteCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALWEBSITE_CREATE)
            .mergeMap((action: ITrialWebsiteCreateAction) => {
                return trialWebsiteApi
                    .createTrialWebsite(action.trialId)
                    .map(response =>
                        CreateSuccess(
                            response.trialWebsite,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialWebsiteEpic = (action$): Observable<ITrialWebsiteValidateSuccessAction | ITrialWebsiteValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALWEBSITE_VALIDATE)
            .mergeMap((action: ITrialWebsiteValidateAction) => {
                return trialWebsiteApi
                    .validateTrialWebsite(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialWebsite, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }